import type { InfiniteData } from '@tanstack/react-query';

export function flatQueryPages<TData>(data: InfiniteData<TData[], unknown> | undefined) {
  if (data) {
    return data.pages.flat();
  } else {
    return [];
  }
}
